import localeData from "./localeData.json";

const messages: Record<string, string> = localeData;
const locale = "en";

export { locale, messages };
